import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import ModalSplitForm from '../components/modal-split-form';
import Alert from '../components/alert';
import {
  ALERT_INNER_MODAL,
  ALERT_TOP_MODAL,

  hideModalInnerAlert,
  hideModalTopAlert,
} from '../actions/ui';

class ModalSplitFormContainer extends Component {
  constructor(props) {
    super(props);
    this.onInnerAlertClose = this.onInnerAlertClose.bind(this);
    this.onTopAlertClose = this.onTopAlertClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prev = !!get(prevProps, `alerts.${ALERT_TOP_MODAL}`, false);
    const next = !!get(this.props, `alerts.${ALERT_TOP_MODAL}`, false);
    const visible = !!this.props.alerts[ALERT_TOP_MODAL];
    const pushDown = el => el.classList.add('with-alert');
    const pushUp = el => el.classList.remove('with-alert');

    if (prev !== next) {
      var list = document.querySelectorAll('.modal-close-link');
      Array.prototype.forEach.call(list, el => visible ? pushDown(el) : pushUp(el));
      window.parent.postMessage({ topAlertVisible: visible }, '*');
    }
  }

  onInnerAlertClose() {
    this.props.hideModalInnerAlert();
  }

  onTopAlertClose() {
    this.props.hideModalTopAlert();
  }

  renderInnerAlert() {
    const innerAlertConfig = this.props.alerts[ALERT_INNER_MODAL];
    if (!innerAlertConfig) return null;

    const { content, type } = innerAlertConfig;

    return (
      <Alert type={type} onClose={this.onInnerAlertClose}>
        {content}
      </Alert>
    );
  }

  renderTopAlert() {
    const topAlertConfig = this.props.alerts[ALERT_TOP_MODAL];
    if (!topAlertConfig) return null;

    const { content, type } = topAlertConfig;

    return (
      <Alert type={type} onClose={this.onTopAlertClose}>
        {content}
      </Alert>
    );
  }

  render() {
    const { leftForm, rightForm } = this.props;

    return (
      <ModalSplitForm
        leftForm={leftForm}
        rightForm={rightForm}
        innerAlert={this.renderInnerAlert()}
        topAlert={this.renderTopAlert()}
      />
    );
  }
}

const mapStateToProps = ({ ui: { alerts } }, ownProps) => {
  return {
    ...ownProps,
    alerts,
  };
};
const mapDispatchToProps = {
  hideModalInnerAlert,
  hideModalTopAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalSplitFormContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/modal-split-form.container.js